import getLoyaltySgBonusCampaignEarnKey from '../getLoyaltySgBonusCampaignEarnKey'

interface LoyaltyEarnKeyBedbankOptions {
  propertyCountryCode: string | undefined
  currentRegionCode: string
}

interface LoyaltyEarnKeyAlwaysOnOptions {
  propertyCountryCode: string | undefined
  currentRegionCode: string
}

// Add additional loyalty product types here
type LoyaltyProductTypeWithOptions = 'hotel_lpc' | 'hotel_lpp_eps'

type LoyaltyEarnKeyConfig =
  | { loyaltyProductType: 'hotel_lpc', options: LoyaltyEarnKeyAlwaysOnOptions }
  | { loyaltyProductType: 'hotel_lpp_eps', options: LoyaltyEarnKeyBedbankOptions }
  // Add other verticals / loyalty product types here
  | { loyaltyProductType: Exclude<App.LoyaltyProductType, LoyaltyProductTypeWithOptions>, options?: undefined }

function getLoyaltyEarnKey(config: LoyaltyEarnKeyConfig): string | undefined {
  switch (config.loyaltyProductType) {
    case 'hotel_lpc':
    case 'hotel_lpp_eps':
      return getLoyaltySgBonusCampaignEarnKey(
        config.options.propertyCountryCode,
        config.options.currentRegionCode,
      )
    default:
      return undefined
  }
}

export default getLoyaltyEarnKey
